<template>
    <div v-if="!$apollo.loading">
        <router-view :project="project"></router-view>
        <div class="uk-section uk-section-small uk-background-dark uk-light competition-dates" v-if="!!projectLinks">
            <div class="uk-container uk-container-large">
                <div class="uk-flex uk-flex-center uk-grid-large" uk-grid>
                    <div v-for="item in projectLinks">
                        <router-link :to="item.link" v-if="item.link.indexOf('//')==-1" class="uk-button">{{item.label}}</router-link>
                        <a :href="item.link" target="_blank" :class="item.class" v-else>{{item.label}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import ProjectCard from '../ProjectCard.vue'
import FloatingBadge  from '../../components/FloatingBadge.vue'
import gql from 'graphql-tag'

// GraphQL query
const readProjectQuery = gql`
    query($urlSegment: String!) {
      readOneProject(filter: { urlSegment: { eq: $urlSegment }}){
        id
        link
        links
        heroName
        heroText
        heroImage {
            large4x3
        }
        image {
            large4x3
        }
        quote
        storytellersText
        storytellersEmbedCode
        storytellersImage {
            medium
        }
        summary
        title
      }
    }
`

export default {
    inject: ['theme', 'state'],
    data() {
        return {
            project: {}
        }
    },
    components: {
        ProjectCard,
        FloatingBadge
    },
    computed: {
        projectLinks() {
            if(this.project.links) {
                var linksArray = []
                var linkClasses = [
                    'uk-button-primary',
                    'button-orange',
                    'button-green'
                ];
                var i = 0;
                _.each(this.project.links.split("\n"), item => {
                    var itemClass = linkClasses[i%3];
                    i++;

                    linksArray.push({
                        link: item.substring(item.indexOf(" "), -1).replace("\r", ""),
                        label: item.substring(item.indexOf(" "), item.length).replace("\r", ""),
                        class: `uk-button theme-button ${itemClass}`
                    })
                })
            }
            return linksArray
        }
    },
    apollo: {
        readProject: {
            // GraphQL query
            query: readProjectQuery,
            variables() {
                return {
                    urlSegment: this.$route.params.id
                }
            },
            update(data) {
                this.project = data.readOneProject

                var subnav = [
                    { title: "Project Home", link: this.project.link }
                ]
                if(this.project.heroText) {
                    subnav.push(
                        { title: "Meet the Hero", link: this.project.link + "/hero" }
                    )
                }
                if(this.project.storytellersText) {
                    subnav.push(
                        { title: "Storytellers", link: this.project.link + "/storytellers" }
                    )
                }
                this.state.api.subnav = subnav

                this.state.setMetaTitle(this.project.title)
            }
        }
    }
}
</script>
